import { supertypeClass, property } from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';
import { RiskFactors } from './RiskFactors';
import { Customer } from './Customer';
import { Financials } from './Financials';

@supertypeClass({ toClient: true, toServer: true })
export class Bankruptcy extends Everything {
  @property({ getType: () => Financials })
  financials: Financials;

  @property({
    values: {
      ch7: 'Chapter 7',
      ch11: 'Chapter 11',
      ch12: 'Chapter 12',
      ch13: 'Chapter 13',
      other: 'Other',
    },
    comment: 'Type of bankruptcy the insured filed for',
  })
  bankruptcyType: string;

  @property({
    rule: ['required'],
  })
  bankruptcyTypeOther: string;

  @property()
  dischargedDate: Date;

  @property()
  notDischarged: boolean = false;

  notDischargedTrigger(): void {
    if (this.notDischarged && this.dischargedDate) {
      this.dischargedDate = null;
    }
  }

  @property({ getType: () => Customer })
  customer: Customer;

  constructor() {
    super();
  }

  static new(customer: Customer): Bankruptcy {
    return new Bankruptcy().init(customer);
  }

  init(customer: Customer): this {
    this.customer = customer;
    return this;
  }
}
